/* First Day — the new-citizen onboarding quest card. Progress computes live on the
   server from data the hub already has; completing all five awards the badge once. */
import { useEffect, useState } from "react";
import { CheckCircle2, Circle, Compass } from "lucide-react";
import api from "@/lib/api";

export function FirstDayCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("nc_token")) return;
    api.get("/nc/onboarding").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  if (data.complete) {
    return (
      <div data-testid="first-day-card" className="border border-emerald-500/30 bg-emerald-500/[0.05] p-5 flex items-center gap-3">
        <Compass className="w-5 h-5 text-emerald-400 shrink-0" />
        <div>
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-emerald-400">First Day badge earned</p>
          <p className="font-mono text-[10px] text-zinc-400 mt-1">You know Bornwood now — the rest of the city is yours to shape.</p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="first-day-card" className="border border-white/10 bg-black/40 p-5 flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Compass className="w-5 h-5 text-nc-blue shrink-0" />
        <div className="flex-1">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-nc-blue">Your first day in Bornwood</p>
          <p className="font-mono text-[10px] text-zinc-500 mt-0.5">Five tiny quests. One badge. Zero homework.</p>
        </div>
        <span data-testid="first-day-count" className="font-sans font-bold text-xl text-zinc-100">{data.done_count}/{data.total}</span>
      </div>
      <div className="h-1.5 bg-white/[0.06] overflow-hidden">
        <div className="h-full bg-nc-blue transition-all duration-500" style={{ width: `${(data.done_count / data.total) * 100}%` }} />
      </div>
      <div className="flex flex-col gap-2">
        {data.quests.map((q) => (
          <div key={q.id} data-testid={`first-day-quest-${q.id}`} className="flex items-start gap-2.5">
            {q.done ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" /> : <Circle className="w-4 h-4 text-zinc-600 shrink-0 mt-0.5" />}
            <div>
              <p className={`font-mono text-[10px] uppercase tracking-[0.15em] ${q.done ? "text-zinc-500 line-through" : "text-zinc-100"}`}>{q.title}</p>
              {!q.done && <p className="font-mono text-[9px] text-zinc-500 mt-0.5 leading-relaxed">{q.hint}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
